import { Outlet, useParams } from 'react-router-dom';
import { useMemo } from 'react';
import useConsoleLayoutConfig from '@/hook/useConsoleLayoutConfig';
import PATH_PAGE from '@/router/path';
import { RouteParams } from '@/router/type';
import { useDemoMode } from '@/context/DemoModeContext';

const DemoOrgSettingsLayout = () => {
  const { orgId } = useParams<RouteParams>();
  const { isDemoMode } = useDemoMode();

  const getPath = (path: string) => (isDemoMode ? `/demo${path}` : path);

  const navbarConfig = useMemo(
    () => ({
      title: 'Organization Settings',
      navbar: [
        {
          label: 'General',
          href: getPath(PATH_PAGE.dashboard.orgSetting.general(orgId || '')),
        },
        {
          label: 'GPU Quota',
          href: getPath(PATH_PAGE.dashboard.orgSetting.quota(orgId || '')),
        },
        {
          label: 'Members',
          href: getPath(PATH_PAGE.dashboard.orgSetting.members(orgId || '')),
        },
        {
          label: 'Workspaces',
          href: getPath(PATH_PAGE.dashboard.orgSetting.workspaces(orgId || '')),
        },
      ],
    }),
    [orgId, isDemoMode]
  );

  useConsoleLayoutConfig({
    navConfig: navbarConfig,
  });

  return (
    <div className="pt-10">
      <Outlet />
    </div>
  );
};

export default DemoOrgSettingsLayout;
